export default {
  page: {
    id: 'bo_seller_global_pagination_page',
    defaultMessage: 'Page {page}',
  },
  navigatePage: {
    id: 'bo_seller_global_pagination_navigate_to_page',
    defaultMessage: 'Navigate to page {page}',
  },
  paginationNextPage: {
    id: 'bo_seller_global_pagination_next_page',
    defaultMessage: 'Next page',
  },
  paginationPreviousPage: {
    id: 'bo_seller_global_pagination_previous_page',
    defaultMessage: 'Previous page',
  },
  paginationLabel: {
    id: 'bo_seller_global_pagination_paginate_label',
    defaultMessage: 'Paginate between results',
  },
}
